import {useEffect, useState} from 'react';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import am4themes_animated from '@amcharts/amcharts4/themes/animated';
import {Skeleton} from '@mui/material';
import {Stack} from '@mui/material';
import {useTranslation} from "react-i18next";

am4core.useTheme(am4themes_animated);

const ChartThirteen = ({data, name, className}) => {
    const [showLoader, setShowLoader] = useState(false);
    const {t} = useTranslation();

    useEffect(() => {
        // Create chart instance
        let chart = am4core.create(name, am4charts.XYChart);

        chart.events.on('ready', () => {
            setShowLoader(false);
        });

        chart.cursor = new am4charts.XYCursor();
        chart.scrollbarX = new am4core.Scrollbar();

        let chartData = data['data'];
        let legendData = data['legend'];

        // Add data
        chart.data = chartData;

        // Create X-axis (category axis)
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.minGridDistance = 15;
        // categoryAxis.title.text = "Year";

        // Create Y-axis for the columsns (value axis)
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.min = 0;
        valueAxis.extraMax = 0.20;
        valueAxis.renderer.minGridDistance = 30;  // Adjust grid spacing
        valueAxis.title.text = t('LOCAL_INDICATORS.IN_MILLION_ALL');

        // Create series for item_1 (column)
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.dataFields.valueY = "own_local_revenue";
        series.dataFields.categoryX = "year";
        series.name = legendData['own_local_revenue'];
        series.columns.template.tooltipText = "{name}: [bold]{valueY}[/]";
        series.columns.template.fill = am4core.color('#67b7dc',);

        series.tooltip.adapter.add("dy", function(dy, target) {
            // Shift tooltip horizontally if needed
            return dy - 50; // Adjust to the right by 10 pixels
        });

        // Add label
        let labelBullet = series.bullets.push(new am4charts.LabelBullet());
        labelBullet.label.text = "{valueY}";
        labelBullet.locationY = 0.5;
        labelBullet.label.hideOversized = true;

        let percentageAxis = chart.yAxes.push(new am4charts.ValueAxis());
        percentageAxis.renderer.opposite = true;  // Place axis on the right side
        // percentageAxis.min = 0;  // Adjust minimum value
        // percentageAxis.max = 40; // Adjust maximum value
        percentageAxis.renderer.labels.template.adapter.add("text", function(text) {
            return text + "%";  // Add percentage sign to labels
        });
        percentageAxis.extraMax = 0.20;
        percentageAxis.renderer.grid.template.disabled = true; // Hide grid lines
        percentageAxis.renderer.inside = false; // Ensure labels are outside the axis
        percentageAxis.renderer.maxLabelPosition = 1; // Allow labels to render fully

        // Add individual percentage bullets without connecting lines
        let percentageSeries = chart.series.push(new am4charts.LineSeries());
        percentageSeries.dataFields.valueY = "change_rate";
        percentageSeries.dataFields.categoryX = "year";
        percentageSeries.name = legendData['change_rate'];
        percentageSeries.strokeWidth = 2; // Remove line by setting strokeWidth to 0
        percentageSeries.yAxis = percentageAxis;
        percentageSeries.tooltipText = "{name}: {valueY}%";
        percentageSeries.stroke = am4core.color("#d42daa");
        percentageSeries.tooltip.getFillFromObject = false;
        percentageSeries.tooltip.background.fill = am4core.color("#d42daa");

        // Add red bullets for percentage points
        let bullet = percentageSeries.bullets.push(new am4charts.CircleBullet());
        bullet.circle.fill = am4core.color("#d42daa"); // Red color
        bullet.circle.radius = 7;

        // Add percentage labels above the bullets
        // let percantageLabelBullet = percentageSeries.bullets.push(new am4charts.LabelBullet());
        // percantageLabelBullet.label.text = "{valueY}%";
        // percantageLabelBullet.dy = -20; // Position label above the bullet
        // percantageLabelBullet.label.fontSize = 14;
        // percantageLabelBullet.tooltipText = "{valueY}%";

        // Add legend
        chart.legend = new am4charts.Legend();

        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.menu.align = 'left';
        chart.exporting.menu.verticalAlign = 'top';

        // Add cursor
        chart.cursor = new am4charts.XYCursor();
    }, []);


    return (
        <>
            <div id={name} style={{width: showLoader ? '0' : '100%', height: showLoader ? '0' : '700px'}} className={className}></div>
            {showLoader && (
                <Stack spacing={1}>
                    <Skeleton variant='text'/>
                    <Skeleton variant='rounded' width={'auto'} height={500}/>
                </Stack>
            )}
        </>
    );
};

export default ChartThirteen;
